import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, db } from '../firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';

// Cria o contexto
const UserContext = createContext(null);

// Hook customizado para facilitar o uso do contexto
export const useUser = () => useContext(UserContext);

// Componente Provedor que irá envolver a aplicação
export const UserProvider = ({ children }) => {
  const [user, loadingAuth] = useAuthState(auth);
  const [userData, setUserData] = useState(null);
  const [loadingData, setLoadingData] = useState(true);

  const fetchUserData = useCallback(async (authUser) => {
    if (!authUser) {
      setUserData(null);
      setLoadingData(false);
      return;
    }
    try {
      const userDocRef = doc(db, 'users', authUser.uid);
      const userDocSnap = await getDoc(userDocRef);

      if (userDocSnap.exists()) {
        let fetchedData = { uid: authUser.uid, ...userDocSnap.data() };

        // Ponto crucial: Busca os módulos da empresa
        if (fetchedData.empresa_id) {
          const empresaDocRef = doc(db, 'Empresas', fetchedData.empresa_id);
          const empresaDocSnap = await getDoc(empresaDocRef);
          if (empresaDocSnap.exists()) {
            fetchedData.modulosAssinados = empresaDocSnap.data().modulosAssinados || [];
          } else {
            fetchedData.modulosAssinados = []; // Garante que o array exista
          }
        }
        setUserData(fetchedData);
      } else {
        setUserData(null); // Usuário autenticado, mas sem perfil no Firestore
      }
    } catch (error) {
      console.error("Erro ao buscar dados do usuário:", error);
      setUserData(null);
    } finally {
      setLoadingData(false);
    }
  }, []);

  useEffect(() => {
    // Se o estado de autenticação mudar, busca os dados do Firestore
    if (!loadingAuth) {
      fetchUserData(user);
    }
  }, [user, loadingAuth, fetchUserData]);

  const value = { userData, loading: loadingAuth || loadingData };

  // Renderiza os filhos apenas quando o carregamento inicial terminar
  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};